module.exports = __webpack_public_path__ + "static/mr-concert-performance-28-9e8fe46cadb07db109de7fc8ea60f094.jpg";